import React from 'react';
import { routeHistory } from '@nackle/biw-web-router';
import { Breadcrumb as Bcrumb } from 'antd';

/**
 * A breadcrumb component
 *
 * {@link https://ant.design/components/breadcrumb#api}
 *
 * @module Breadcrumb
 * @param {object} props - the component props
 * @param {boolean} [props.spa] - boolean of whether the breadcrumb is used in a single page application
 * @param {array} [props.items] - the breadcrumb items
 * @param {object} [props.children] - the child props, these will render inside the breadcrumb component
**/
export const Breadcrumb = ( { spa, ...props } ) => {
    const { items, ...rest } = props;

    const handleNavigate = ( path ) => {
        routeHistory.push( path );
    };

    const updatedBreadcrumbItems = items?.map( ( item ) => {
        const route = item.path || item.href;
        if ( route ) {
            return {
                title: <span>{ item.title }</span>,
                onClick: ( e ) => {
                    e.preventDefault();
                    handleNavigate( route );
                }
            };
        }
        return { title: item.title };
    } ) || [];

    return (
        spa ? <Bcrumb items={ updatedBreadcrumbItems } { ...rest } /> : <Bcrumb items={ items } { ...rest } />
    );
};
